<template>
    <div class="section-box">

        <el-form ref="searchForm" inline label-width="120px">
            <el-form-item label="跳转到日期：">
                <el-date-picker v-model="searchTime" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="confirmDate">确认</el-button>
            </el-form-item>
        </el-form>
        <div class="calendar-box">
            <el-calendar v-model="selectDate" ref="elCalendarRef">
                <template slot="dateCell" slot-scope="{date, data}">

                    <!-- <p :class="data.isSelected ? 'is-selected' : ''">
                        {{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : '' }}
                    </p> -->
                    <!-- <p>type:{{ data.type }}</p> 判断是否是当前月份 -->
                    <!-- <p>day:{{ data.day }}</p> -->
                    <!-- <p>day:{{ holidays[data.day] }}</p> -->
                    <!-- <p>isSelected:{{ data.isSelected }}</p> -->
                    <div class="day-cell">
                        <p> {{ data.day.split('-').slice(1).join('-') }}</p>
                        <span class="tag" :class="'tag' + getDateType(data.day)" 
                        v-if="getDateType(data.day) > 0&&getDateType(data.day) <5">
                            {{ dayTypeLabel[getDateType(data.day)] }} <i class="el-icon-close" @click="removeDate(data.day)"></i>
                        </span>

                        <el-dropdown v-if="getDateType(data.day) == 0 && data.isSelected" @command="setHoliday">
                            <span class="el-dropdown-link">
                                设置日期<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="4">普通节假日</el-dropdown-item>
                                <el-dropdown-item command="1">3倍节假日</el-dropdown-item>
                                <el-dropdown-item command="3" v-if="isWorkDay(data.day)">设置为周末</el-dropdown-item>
                                <el-dropdown-item command="2" v-if="!isWorkDay(data.day)">设置为工作日 </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </template>
            </el-calendar>
        </div>
    </div>
</template>

<script>
import {
    GetDayProperty, AddHoliday, RemoveHoliday
} from "@/service/sys";

export default {
    data() {
        return {
            searchTime: "",

            selectDate: new Date(),
            dayList: null,
            elCalendar: null,
            dayTypeLabel: {
                1: "3倍节假日",
                2: "按工作日价格",
                3: "按周末价格",
                4: "普通节假日"
            }
        }
    },
    mounted() {
        this.elCalendar = this.$refs.elCalendarRef;
    },
    created() {

        // this.getDayProperty('2025-09-01');
    },
    watch: {
        selectDate(newval, oldval) {
            console.log("newval:" + JSON.stringify(newval));

            console.log("oldval" + JSON.stringify(oldval));

            // var date_pro = this.getDayProperty('2025-09-01');
        },
        'elCalendar.curMonthDatePrefix': { //监听月份的变化
            handler(newval, oldval) {
                //console.log("oldval2222", newval, oldval);
                this.getMonthDay(newval + '-01');
            },
            // immediate: true
        }
    },
    methods: {
        confirmDate() {
            console.log("searchTime:" + this.searchTime)
            if (this.searchTime == "") {
                return this.$message.warning('请选择跳转日期');
            }

            this.selectDate = new Date(this.searchTime);
        },
        getMonthDay(date) {
            GetDayProperty({ Date: date }).then((res) => {
                if (res.Result == 0) {
                    return this.$message.warning(res.Message);
                }
                this.dayList = res.Data;
                console.log("dayList:" + JSON.stringify(this.dayList))
            })
        },
     
        getDateType(date) {
            // 日期的类别：
            //  1.设置为节假日,且是3倍工资的节假日，比如10.1国庆节，前3天是3倍后面就不是了，则前3天的日期类型为1
            //  2.周末设置为工作日 
            //  3.工作日设置为周末
            //  4.设置为普通节假日，比如10.1国庆节，整个国庆节放假都是普通节假日
            if (this.dayList) {
                var date = this.dayList.find(f => f.Date == date);
                if (date) {
                    var dayType = date.DayType;
                    return dayType;
                }
            }
            return 0;
        },
        isWorkDay(date) {
            var day = this.getDateWeek(date);
            return day >= 1 && day <= 5;
        },
        //获取周几
        getDateWeek(date) {
            // 获取星期几，0代表周日，1代表周一，以此类推
            const day = new Date(date).getDay();
            return day;
        },
        setHoliday(dateType) {
            console.log(dateType);
            if (this.selectDate) {
                var str = JSON.stringify(this.selectDate);
                var date = str.substring(1, 11);
                console.log("selectDate:" + date);

                AddHoliday({ Date: date, DateType: dateType }).then((res) => {
                    if (res.Result == 0) {
                        return this.$message.warning(res.Message);
                    }

                    for (var i = 0; i < this.dayList.length; i++) {
                        if (this.dayList[i].Date == date) {
                            this.dayList[i].DayType = dateType;
                        }
                    }

                    return this.$message.success(res.Message);
                })
            }
        },
        removeDate(date) {
            RemoveHoliday({ Date: date }).then((res) => {
                if (res.Result == 0) {
                    return this.$message.warning(res.Message);
                }

                for (var i = 0; i < this.dayList.length; i++) {
                    if (this.dayList[i].Date == date) {
                        this.dayList[i].DayType = 0;
                    }
                }

                return this.$message.success(res.Message);
            });
        }

    }

}

</script>

<style scoped lang="scss">
.is-selected {
    color: #1989FA;
}

.section-box {

    .calendar-box {
        padding: 10px;
        border: 1px solid rgb(220, 223, 230);

        .day-cell {
            // border: 1px solid red;
            position: relative;

            p {
                //  border: 1px solid blue;
            }

            span.tag {
                font-size: 12px;
                display: block;
                padding: 3px;
                background: #1989FA;
                color: white;
                display: flex;
                align-items: center;
                position: relative;

                i {
                    float: right;
                    position: absolute;
                    right: 5px;

                    // border: 1px solid red;
                    padding: 2px 5px;
                }
            }

            span.tag1 {
                background: #f56c6c;
            }

            span.tag2 {
                background: rgb(58, 142, 230);
            }

            span.tag3 {
                background: #67c23a;
            }

            span.tag4 {
                background: #e6a23c;
            }
        }



    }
}
</style>